<template>
  <figure style="width: 100%; height: 100%;display: flex;align-items: center;justify-content: center;">
    <chart :options="pieOptions" @click="topicFilter" style='width: 100%; height: 100%' ref="pie" auto-resize v-if="dataState === 'ready'"></chart>
    <template v-else-if="dataState === 'loading'">
      <center>
        <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
      </center>
    </template>
    <template v-else-if="dataState === 'noData'">
      <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="primary--text" style="font-size: 40px !important;width:100%">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">no data found</p></div>
    </template>
    <template v-else-if="dataState === 'error'">
      <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="error--text" style="font-size: 40px !important">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
    </template>
  </figure>
</template>

<script>
import axios from 'axios'
import underscore from 'underscore'
import { mapGetters, mapMutations } from 'vuex'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dataState: 'loading',
      pieOptions: {
        tooltip: {trigger: 'item', formatter: '{a} <br/>{b} : {c} ({d}%)'},
        series: [{
          name: 'Topics',
          type: 'pie',
          data: [
            {value: 0, name: ''}
          ]
        }]
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('filters', ['getTopic', 'getQuery']),
    filterTopic: function () {
      return this.getTopic
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setCustomFilters', 'resetTopicFilter']),
    topicFilter: function (type) {
      var filter = this.filterTopic.slice()
      var index = filter.indexOf(type.name)
      if (index >= 0) {
        filter.splice(index, 1)
        this.setCustomFilters({topic: filter})
      } else {
        filter.push(type.name)
        this.setCustomFilters({topic: filter})
      }
    },
    getData: function () {
      this.dataState = 'loading'
      axios.all([
        this.$store.dispatch('getArticlesTopics', this.getQuery({sortBy: '_article_count', order: 'desc', pageSize: 25}))
      ]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.pieOptions.series = []
          var temp = []

          for (var i = 0; i < response.data.payload.length; i++) {
            temp.push({value: response.data.payload[i]._article_count, name: response.data.payload[i]._topic})
          }

          this.pieOptions.series.push({
            name: 'Topics',
            type: 'pie',
            data: temp
          })

          if (temp.length === 0) {
            this.dataState = 'noData'
          } else {
            this.dataState = 'ready'
          }
        } else {
          this.dataState = 'error'
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.dataState = 'error'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (!underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.getData()
        }
      }
    },
    loading: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal === true) {
          let pie = this.$refs.pie
          if (pie) {
            pie.showLoading({
              text: '',
              color: '#4ea397',
              maskColor: 'rgba(255, 255, 255, 0.4)'
            })
          }
        } else {
          let pie = this.$refs.pie
          if (pie) {
            pie.hideLoading()
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/ArticlesTopicsPieChart.vue